import React, { useEffect, useState } from 'react';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './Admin.css';
import SEO from '../Components/SEO';
import { useUser } from '../Context/UserContext';
import { PERMISSIONS } from '../Utils/permissions';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();
  const { user, loading, permissions } = useUser();

  // Redirect only once the auth state *and* permissions have resolved, so we
  // never bounce into /admin before the guard knows who this user is.
  useEffect(() => {
    if (loading || !user) return;
    if (permissions?.[PERMISSIONS.ADMIN_PANEL_ACCESS]) {
      navigate('/admin', { replace: true });
    } else {
      setError('This account does not have access to the admin panel.');
      setSubmitting(false);
      signOut(auth).catch(() => {});
    }
  }, [user, loading, permissions, navigate, auth]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Navigation happens in the effect above once permissions are loaded.
    } catch (err) {
      setError('Failed to login. Please check your credentials.');
      setSubmitting(false);
      console.error(err);
    }
  };

  return (
    <>
      <SEO
        title="Admin Login"
        description="Admin login - VetCare Store"
        noIndex={true}
        canonical={typeof window !== 'undefined' ? `${window.location.origin}/admin/login` : ''}
        type="website"
      />
      <div style={{
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        backgroundColor: '#f6f6f7'
      }}>
        <div className="admin-container" style={{maxWidth: '500px', width: '100%', margin: '0 20px'}}>
          <div className="admin-card">
        <div className="admin-header">
          <h2>Admin Login</h2>
        </div>
        
        {error && <div style={{background: '#fee2e2', color: '#dc2626', padding: '10px', borderRadius: '8px', marginBottom: '20px', textAlign: 'center'}}>{error}</div>}
        
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              className="custom-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              className="custom-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="submit-btn" disabled={submitting}>
            <ion-icon name="log-in-outline"></ion-icon> {submitting ? 'Logging in…' : 'Login'}
          </button>
        </form>
        </div>
      </div>
      </div>
    </>
  );
}
